(function () {
	'use strict';
	$(document).ready(function () {

		var swiperTileImages = new Swiper('.swiper-tile-images', {
			slidesPerView: 1,
			spaceBetween: 16,
			navigation: {
				prevEl: '.swiper-button-prev',
				nextEl: '.swiper-button-next',
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			}
		});

	});
}(jQuery));
